import Divider from '@/ui/atoms/Divider'

const DividerQuestion = () => <Divider className="-mb-10 -mt-8" />

export default DividerQuestion
